export enum EInterventionType {
    IBGN = 1,
    MPCE = 2,
    IBD = 3,
    EAU = 4,
    LAC = 5,
    IBMR = 6,
    MGCE = 7,
    IML = 8,
    Cyano = 9,
    // IBDL = 10
}
